import { ProgramShippingLocationDto } from './../../../client-core/dtos/programs.model';
import { NotificationService } from 'app/shared/utils/notification.service';
import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { BsModalRef, BsModalService, TypeaheadMatch } from 'ngx-bootstrap';
import { ValidationMessage } from 'app/validation';
import { ProgramDto, ShippingLocationDto } from 'app/client-core/dtos/programs.model';
import { ProgramService } from 'app/client-core/services/program.service';

const $ = jQuery;
@Component({
    selector: 'address-list-modal',
    templateUrl: './address-list.modal.component.html',
    styleUrls: [
        './address-list.scss'
    ]
})
export class AddressListModalComponent implements OnInit {
    ready: boolean;
    public validationMessages: ValidationMessage;
    @Input() addresses: ProgramShippingLocationDto[] = [];
    cachedAddresses: ProgramShippingLocationDto[] = [];
    search: string;
    selectAll: boolean;
    filteredAddresses: ProgramShippingLocationDto[] =[];
    sortOrder = 'asc';
    sortColumn = '';
    
    constructor(
        public modalRef: BsModalRef,
        private programService: ProgramService,
        private notificationService: NotificationService
    ) {
    }

    ngOnInit() {
        this.ready = true;
        this.cachedAddresses = this.addresses;
        this.filteredAddresses = this.cachedAddresses;
    }

    close(): void {
        this.addresses = [];
        this.filteredAddresses = [];
        this.cachedAddresses = [];
        this.modalRef.hide();
    }

    onAddressSelected(id, selected) {
        this.cachedAddresses = this.cachedAddresses.map(a => {
            return {
                ...a,
                selected: a.deliveryLocationId === id ? selected : a.selected
            }
        });
    }
    
    selectAllLines() {
        this.selectAll = !this.selectAll;
        let addressesToUpdate = this.cachedAddresses.map(a => a.deliveryLocationId);
        if (this.search) {
            addressesToUpdate = this.cachedAddresses
            .filter(a => a.location.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
            .map(a => a.deliveryLocationId);
        }
        this.cachedAddresses = this.cachedAddresses.map(a => {
            return {
                ...a,
                selected: addressesToUpdate.includes(a.deliveryLocationId) ? this.selectAll : a.selected
            }
        });
        this.filteredAddresses = this.filteredAddresses.map(a => {
            return {
                ...a,
                selected: addressesToUpdate.includes(a.deliveryLocationId) ? this.selectAll : a.selected
            }
        });
    }

    filterAddresses() {
        if (!this.search) {
            this.filteredAddresses = this.cachedAddresses;
        }
        this.filteredAddresses = this.cachedAddresses
            .filter(a => a.location.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
    }

    deleteAddresses() {
        const selectedAddresses = this.cachedAddresses.filter(a => a.selected);
        this.programService.shippingLocationSelectionUpdated.next(selectedAddresses);
        this.cachedAddresses = this.cachedAddresses.filter(a => !selectedAddresses.map(sa => sa.deliveryLocationId).includes(a.deliveryLocationId));
        this.filteredAddresses = this.filteredAddresses.filter(a => !selectedAddresses.map(sa => sa.deliveryLocationId).includes(a.deliveryLocationId));
    }

    orderList(column) {
        if (column != this.sortColumn) {
            this.sortColumn = column;
            this.sortOrder = 'asc';
        } else {
            if (this.sortOrder == 'asc') {
                this.sortOrder = 'desc';
            } else {
                this.sortOrder = 'asc';
            }
        }

        if (this.sortOrder == 'asc') {
            if (Number.isInteger(this.filteredAddresses[0][column])) {
                this.filteredAddresses.sort((a, b) => a[column] - b[column]);
            } else {
                this.filteredAddresses.sort((a, b) => a[column].localeCompare(b[column]));
            }
        } else {
            if (Number.isInteger(this.filteredAddresses[0][column])) {
                this.filteredAddresses.sort((a, b) => b[column] - a[column]);
            } else {
                this.filteredAddresses.sort((a, b) => b[column].localeCompare(a[column]));
            }
        }

        console.log(this.sortOrder, this.sortColumn, column, this.filteredAddresses)
    }
}





// WEBPACK FOOTER //
// ./src/app/shared/components/address-list/address-list.modal.component.ts